var _style, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgRecetario = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M309.5,12v119h119L309.5,12z M279.8,131V12H116.1c-24.6,0-44.6,20-44.6,44.6v386.8c0,24.6,20,44.6,44.6,44.6 h267.8c24.6,0,44.6-20,44.6-44.6V160.8H310.3C293,160.8,279.8,147.5,279.8,131z M339.3,292.5v34c0,7.1-5.7,12.8-12.7,12.8l-46.8-0.8 v46.8c0,7.9-5.7,13.6-12.7,13.6h-34c-7.1,0-12.7-5.7-12.7-12.7v-47.6l-46.8,0.8c-7.1,0-12.7-5.7-12.7-12.7v-34 c0-7.1,5.7-12.7,12.7-12.7h46.8V233c0-7.1,5.7-12.7,12.7-12.7h34c7.1,0,12.8,5.7,12.8,12.7v46.8h46.8 C333.6,279.8,339.3,285.4,339.3,292.5z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRecetario, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/recetario.ba37ca48.svg";
export { ForwardRef as ReactComponent };